var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcPlusBold = function SvgIcPlusBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.531 3.75a1.406 1.406 0 0 1 1.406 1.406v7.969h7.97a1.406 1.406 0 0 1 0 2.813h-7.97v7.968a1.406 1.406 0 0 1-2.812 0v-7.968H5.156a1.406 1.406 0 0 1 0-2.813h7.969V5.156a1.406 1.406 0 0 1 1.406-1.406"
  })));
};
export default SvgIcPlusBold;